"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _formatters = require("../../utils/formatters");
var _types = require("../../utils/types");
var _ImageIcon = _interopRequireDefault(require("../common/ImageIcon/ImageIcon"));
var _Stopwatch = _interopRequireDefault(require("../common/Stopwatch/Stopwatch"));
require("./MailListItem.scss");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MailListItem = function MailListItem(_ref) {
  var id = _ref.id,
    _ref$contact = _ref.contact,
    user = _ref$contact.name,
    account = _ref$contact.account,
    subject = _ref.subject,
    mails = _ref.mails,
    campaign = _ref.campaign,
    date = _ref.date,
    unread = _ref.unread,
    active = _ref.active,
    timeUnattended = _ref.timeUnattended,
    warning = _ref.warning,
    onClick = _ref.onClick,
    activeMail = _ref.activeMail,
    onMailClick = _ref.onMailClick;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)('commons'),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var lang = i18n.language.slice(0, 2);
  var multiple = mails.length > 1;
  var hasAttachments = !multiple && mails[0] && mails[0].media && mails[0].media.length > 0;
  var displaySubject = mails.length === 0 ? /*#__PURE__*/_react["default"].createElement("em", {
    className: "uin-lic-new-ph"
  }, t('new-convo')) : subject || t('no-subject');
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: "uin-list-item uin-mail-list-item ".concat(open ? 'open' : '', " ").concat(active ? 'active' : '', " ").concat(warning ? 'warning' : ''),
    onClick: onClick
  }, !multiple && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-bar"
  }), unread && !open && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-mli-message' + (multiple ? ' multiple' : '')
  }, /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
    name: campaign.name,
    image: campaign.image
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-preview"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-row r1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-col a1 c100"
  }, user), !multiple && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-col a2 c600"
  }, (0, _formatters.formatDateShort)(mails[0].date, lang), " ", (0, _formatters.formatTimeShort24hrs)(mails[0].date, lang), " ", lang == 'es' ? 'h' : 'hr'), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-col a3"
  }, multiple ? mails.length : '')), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-mli-row r2 ' + (multiple ? 'c900' : 'c500')
  }, displaySubject), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-row r3 c600"
  }, /*#__PURE__*/_react["default"].createElement("div", null, account), timeUnattended !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-lic-timeout"
  }, /*#__PURE__*/_react["default"].createElement(_Stopwatch["default"], {
    initialTime: timeUnattended,
    currentDate: date
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-icons"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon mail uin-lic-icon"
  }), hasAttachments && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clip"
  })), multiple && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-chevron",
    onClick: function onClick(e) {
      e.stopPropagation();
      setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon chevron' + (open ? '-up' : '')
  }))), multiple && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mli-submessages",
    style: {
      height: open ? mails.length * 61 + 'px' : '0px'
    }
  }, mails.map(function (mail) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: mail.id,
      className: 'uin-mli-mails-accordion' + (activeMail === mail.id ? ' active' : ''),
      onClick: function onClick() {
        return onMailClick(mail.id);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-lic-bar"
    }), !mail.seen && /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-lic-dot"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-mli-row r1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-mli-col a1 c100"
    }, mail.origin === _constants.MSG_SOURCE.USER ? user : 'AGENT'), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-mli-col a2"
    }, (0, _formatters.formatDateShort)(mail.date, lang), " ", (0, _formatters.formatTimeShort24hrs)(date, lang), " ", lang == 'es' ? 'h' : 'hr')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-mli-row r2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-mli-col b1"
    }, mail.content), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-mli-col b2"
    }, mail.media && mail.media.length > 0 && /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon clip"
    }))));
  })));
};
MailListItem.propTypes = {
  id: _propTypes["default"].number,
  contact: _types.contactType.isRequired,
  campaign: _types.campaignType.isRequired,
  subject: _propTypes["default"].string,
  mails: _propTypes["default"].arrayOf(_types.messageType),
  date: _propTypes["default"].instanceOf(Date).isRequired,
  unread: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  activeMail: _propTypes["default"].number,
  timeUnattended: _propTypes["default"].instanceOf(Date),
  warning: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onMailClick: _propTypes["default"].func
};
MailListItem.defaultProps = {
  mails: [],
  timeUnattended: null
};
var _default = exports["default"] = MailListItem;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MailListItem/MailListItem.js
// module id = 1415
// module chunks = 0